import React from "react";

const Default = ({ project }) => {
  return <span>Contact Admin please for project ID {project.id}</span>;
};

export default Default;
